<template>
	<v-container fluid class="px-0">
		<v-form ref="form">
			<v-row>
				<v-col cols="12">
					<v-select v-model="typeId" :items="types" item-text="name" item-value="id"
						menu-props="bottom, offsetY" :label="targetLabel" :disabled="disabled" @change="onTypeIdChanged" />
				</v-col>
				<v-col cols="12" v-if="typeId === 1">
					<v-select v-model="workplaceIds" chips multiple deletable-chips
						:items="filterByProfile ? workplacesByProfile : workplaces" item-text="name" item-value="id"
						menu-props="bottom, offsetY" :disabled="disabled"
						:label="$t('wkt.admin.activity-types.edit-activity-types.workplaces')" />
				</v-col>
				<v-col cols="12" v-if="typeId === 1">
					<v-select v-model="departmentIds" chips multiple deletable-chips
						:items="filterByProfile ? departmentsByProfile : departments" item-text="name" item-value="id"
						menu-props="bottom, offsetY" :disabled="disabled"
						:label="$t('wkt.admin.activity-types.edit-activity-types.departments')" />
				</v-col>
				<v-col cols="12" v-if="typeId === 1">
					<v-select v-model="legalEntityIds" chips multiple deletable-chips
						:items="legalEntities" item-text="legalEntityName" item-value="id"
						menu-props="bottom, offsetY" :disabled="disabled"
						:label="$t('wkt.admin.legal-entities.title')" />
				</v-col>
				<v-col cols="12" v-if="typeId === 2">
					<v-select v-model="projectIds" chips multiple deletable-chips :items="projects"
						:item-text="item => `${item.shortName} - ${item.description}`" item-value="id"
						menu-props="bottom, offsetY" :disabled="disabled"
						:label="$t('wkt.admin.activity-types.edit-activity-types.access-type_project')" />
				</v-col>
				<v-col cols="12" v-if="typeId === 3">
					<v-autocomplete v-model="employeeIds" chips multiple clearable deletable-chips :items="employees"
						:item-text="item => `${item.lastname}, ${item.firstname} ${!item.isEnabled ? ` (${this.$t('wkt.admin.edit-employee-window.disabled')})` : ''}`"
						item-value="id" :filter="filterEmployees" menu-props="bottom, offsetY"
						:label="$t('wkt.admin.common.filters.employee_placeholder')"
						:placeholder="$t('wkt.admin.common.filters.employee_placeholder')"
						:rules="[validationRules.requiredMultiple]" :disabled="disabled"
						:readonly="disabled" />
				</v-col>
			</v-row>
		</v-form>
	</v-container>
</template>

<script>
import BaseModule from './BaseModule.js';
import api from '../../api/worktime.js';
import gwt from '../../api/gwt.js';

export default {
	name: 'TargetManager',
	mixins: [BaseModule],
	props: ['types', 'filterByProfile', 'selectedIds', 'isProject', 'targetLabel', 'workplaceIdsAsString', 'departmentIdsAsString', 'legalEntityIdsAsString', 'projectIdsAsString', 'employeeIdsAsString', 'disabled', 'value'],
	components: {
	},
	watch: {
		selectedIds: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!this.companyId || (this.companyId && gwt.getSessionInformation().company.id !== this.companyId)) {
					this.companyId = gwt.getSessionInformation().company.id;

					this.getDepartments();
					this.getWorkplaces();
					this.getLegalEntities();
					this.getProjects();
				}

				this.typeId = 0;
				this.workplaceIds = [];
				this.departmentIds = [];
				this.legalEntityIds = [];
				this.projectIds = [];
				this.employeeIds = [];
			}
		},
		filterByProfile: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (oldValue && newValue !== oldValue) {
					this.getDepartments();
					this.getWorkplaces();
				}
			}
		},
		workplaceIdsAsString: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!newValue || newValue.length === 0) {
					this.workplaceIds = [];
					return;
				}

				this.workplaceIds = newValue.split(',').map(Number);
			}
		},
		departmentIdsAsString: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!newValue || newValue.length === 0) {
					this.departmentIds = [];
					return;
				}

				this.departmentIds = newValue.split(',').map(Number);
			}
		},
		legalEntityIdsAsString: {
			immediate: true,
			deep: true,
			handler(newValue) {
				if (!newValue || newValue.length === 0) {
					this.legalEntityIds = [];
					return;
				}

				this.legalEntityIds = newValue.split(',').map(Number);
			}
		},
		projectIdsAsString: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!newValue || newValue.length === 0) {
					this.projectIds = [];
					return;
				}

				this.projectIds = newValue.split(',').map(Number);
			}
		},
		employeeIdsAsString: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!newValue || newValue.length === 0) {
					this.employeeIds = [];
					return;
				}

				this.employeeIds = newValue.split(',').map(Number);
			}
		},
		value(newVal) {
		this.typeId = newVal;
		},
		workplaceIds(newVal) {
		this.$emit('update:workplaceIdsAsString', newVal.join(','));
		},
		departmentIds(newVal) {
		this.$emit('update:departmentIdsAsString', newVal.join(','));
		},
		legalEntityIds(newVal) {
		this.$emit('update:legalEntityIdsAsString', newVal.join(','));
		},
		projectIds(newVal) {
		this.$emit('update:projectIdsAsString', newVal.join(','));
		},
		employeeIds(newVal) {
		this.$emit('update:employeeIdsAsString', newVal.join(','));
		},
	},
	data() {
		return {
			typeId: this.value,
			companyId: null,
			workplaceIds: [],
			departmentIds: [],
			legalEntityIds: [],
			projectIds: [],
			employeeIds: [],
			workplaces: [],
			workplacesByProfile: [],
			departments: [],
			departmentsByProfile: [],
			legalEntities: [],
			employees: [],
			projectEmployees: [],
			projects: [],
			myTeam:[]
		}
	},
	mounted() {
		this.typeId = this.value
		// this.resetComponentState();
		// this.loadData();
	},
	methods: {
		// resetComponentState() {
		// 	this.typeId = 0;
		// 	this.companyId = null;
		// 	this.workplaceIds = [];
		// 	this.departmentIds = [];
		// 	this.projectIds = [];
		// 	this.employeeIds = [];

		// 	this.workplaces = [];
		// 	this.workplacesByProfile = [];
		// 	this.departments = [];
		// 	this.departmentsByProfile = [];
		// 	this.projects = [];
		// 	this.employees = [];
		// 	this.loadData();
		// },
		loadData() {
			this.getDepartments();
			this.getWorkplaces();
			this.getLegalEntities();
			this.getProjects();
		},
		getLegalEntities() {
			const legalEntities = gwt.getLegalEntities();
			if (legalEntities && legalEntities.length > 0) {
				this.legalEntities = legalEntities;
				return;
			}

			api.getLegalEntities(
				(data) => {
					this.legalEntities = data || [];
				},
				(error) => {
					this.loading = false;
					this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
				}
			);
		},
		getWorkplaces() {
			this.workplaces = this.filterByProfile ? gwt.getWorkplacesByProfile() : gwt.getWorkplaces();

			if (!this.workplaces || this.workplaces.length === 0) {
				api.getWorkPlaces(
				(data) => {
					this.workplaces = data;
					if (this.filterByProfile) {
						this.filterWorplacesByProfile();
					}
				},
				(error) => {
					this.loading = false;
					this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
				}
				);
			} else if (this.filterByProfile) {
				this.filterWorplacesByProfile();
			}
		},
		getDepartments() {
			this.departments = this.filterByProfile ? gwt.getDepartmentsByProfile() : gwt.getDepartments();

			if (!this.departments || this.departments.length === 0) {
				api.getStaff(
				(data) => {
					this.departments = data;
					if (this.filterByProfile) {
					this.filterDepartmentsByProfile();
					}
					this.getAllEmployees();
				},
				(error) => {
					this.loading = false;
					this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
				}
				);
			} else {
				if (this.filterByProfile) {
				this.filterDepartmentsByProfile();
				}
				this.getAllEmployees();
			}
		},
		getProjects() {
			api.getProjects(
				(data) => {
					const profile = gwt.getSessionProfile();
					let allowedProjects = [];

					if (this.filterByProfile && profile && profile.projects && profile.projects.trim() !== '') {
						allowedProjects = profile.projects.split(',').map(id => id.trim());
						this.projects = data.filter(x => allowedProjects.includes(String(x.id)));
					} else {
						this.projects = data;
					}
				},
				(error) => {
					this.loading = false;
					this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
				}
			);
		},
		getAllEmployees() {
		this.employees = [];

		for (const department of this.departments) {
			this.employees = [...this.employees, ...department.employees];
		}

		const profile = gwt.getSessionProfile();
		let allowedDepartments = [];
		let allowedWorkplaces = [];
		let allowedLegalEntities = [];
		let allowedProjects = [];
		let onlyMyTeam = false;

		if (this.filterByProfile) {
			if (profile.departments) {
				allowedDepartments = profile.departments.split(',').map(Number);
			}
			if (profile.workplaces) {
				allowedWorkplaces = profile.workplaces.split(',').map(Number);
			}
			if (profile.onlyMyTeam) {
				onlyMyTeam = true;
			}
			if (profile.legalEntities) {
				allowedLegalEntities = profile.legalEntities.split(',').map(Number);
			}
			if (profile.projects && profile.projects.trim()) {
				allowedProjects = profile.projects.split(',').map(id => Number(id.trim()));
			}
		} else {
			allowedDepartments = [];
			allowedWorkplaces = [];
			allowedLegalEntities = [];
			allowedProjects = [];
			onlyMyTeam = false;
		}

		const myTeamIds = onlyMyTeam ? this.getMyTeamIds() : null;

		this.employees = this.employees.filter(e => {
			const byDepartment = allowedDepartments.length === 0 || allowedDepartments.includes(e.departmentId);
			const byWorkplace = allowedWorkplaces.length === 0 || allowedWorkplaces.includes(e.workplaceId);
			const byLegalEntity = allowedLegalEntities.length === 0 || allowedLegalEntities.includes(e.legalEntityId);
			const inMyTeam = !onlyMyTeam || (myTeamIds && myTeamIds.includes(e.id));
			const isEnabled = this.typeId === 3 ? true : e.isEnabled === true;
			return byDepartment && byWorkplace && byLegalEntity && inMyTeam && isEnabled;
		});

		if (this.filterByProfile && allowedProjects.length) {
			this.getProjectEmployees((projectEmployeeIds) => {
				this.employees = this.employees.filter(e => projectEmployeeIds.includes(e.id));
			}, /*pasamos aquí los projectIds del perfil*/ allowedProjects);
		}

		this.employees.sort((a, b) => {
			const fullnameA = this.getEmployeeFullname(a).toLowerCase();
			const fullnameB = this.getEmployeeFullname(b).toLowerCase();
			if (fullnameA === fullnameB) return 0;
			return fullnameA > fullnameB ? 1 : -1;
		});
		},
		// eslint-disable-next-line no-unused-vars
		filterEmployees(item, queryText, itemText) {
			const normalizedFirstname = item.firstname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
			const normalizedLastname = item.lastname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
			const normalizedQueryText = queryText.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

			return normalizedFirstname.indexOf(normalizedQueryText) > -1 ||
				normalizedLastname.indexOf(normalizedQueryText) > -1;
		},
		filterWorplacesByProfile() {
			this.workplacesByProfile = [];

			if (gwt.getSessionInformation()) {
				const profile = gwt.getSessionProfile();

				if (profile) {
					if (!profile.workplaces || profile.workplaces.trim() === '') {
						this.workplacesByProfile = this.workplaces;
					} else {
						const workplaceIds = profile.workplaces.split(',').map(id => id.trim());
						this.workplacesByProfile = this.workplaces.filter(x => workplaceIds.includes(String(x.id)));
					}
				} else if (this.isEmulationEnabled()) {
					this.workplacesByProfile = this.workplaces;
				}
			}
		},
		filterDepartmentsByProfile() {
			this.departmentsByProfile = [];

			if (gwt.getSessionInformation()) {
				const profile = gwt.getSessionProfile();

				if (profile) {
					if (!profile.departments) {
						this.departmentsByProfile = this.departments;
					} else {
						if (profile.departments) {
							const departmentIds = profile.departments.split(',');

							if (departmentIds) {
								this.departmentsByProfile = this.departments.filter(x => departmentIds.includes(String(x.id)));
							}
						}
					}
				} else if (this.isEmulationEnabled()) {
					this.departmentsByProfile = this.departments;
				}
			}
		},
		getSelectedEmployeeIds(callback) {
			let items = [];
			let backImmediately = true;

			if (!this.$refs.form.validate()) {
				return items;
			}

			if (this.typeId === 0) { // 0 - Company
				items = [...this.employees.filter(x => x.isEnabled)];
			} else if (this.typeId === 1) { // 1 - Group
				if (this.workplaceIds.length === 0 && this.departmentIds.length === 0 && this.legalEntityIds.length === 0) {
					items = [...this.employees];
				} else {
					items = [...this.employees.filter(x => {
						const matchesWorkplace = this.workplaceIds.length === 0 || this.workplaceIds.includes(x.workplaceId);
						const matchesDepartment = this.departmentIds.length === 0 || this.departmentIds.includes(x.departmentId);
						const matchesLegalEntity = this.legalEntityIds.length === 0 || this.legalEntityIds.includes(x.legalEntityId);
						return matchesWorkplace && matchesDepartment && matchesLegalEntity && x.isEnabled;
					})];
				}
			} else if (this.typeId === 2) { // Project
				backImmediately = false;
				this.getProjectEmployees((employeeIds) => {
					let uniqueEmployeeIds = [...new Set(employeeIds)];

					items = uniqueEmployeeIds;

					// if (this.selectedIds.length > 0) {
					// 	items = [...items.filter(x => !this.selectedIds.includes(x))];
					// }
					callback(items);
				});
				return;
			} else if (this.typeId === 3) { // 3 - Employee
				items = [...this.employees.filter(x => this.employeeIds.includes(x.id))];
			} else if (this.typeId === 4) { // 4 - My team
				if (gwt.getSessionInformation().myTeam && gwt.getSessionInformation().myTeam.length > 0 && !this.filterByProfile) {
					if (this.isProject) {
						const myTeamIds = gwt.getSessionInformation().myTeam.map(x => x.id);
						items = [...this.employees.filter(x => myTeamIds.includes(x.id) && x.isEnabled)];
					} else {
						items = [...gwt.getSessionInformation().myTeam.filter(x => x.isEnabled)];
					}
				} else {
					const rawTeam = gwt.getSessionInformation().myTeam || [];
					const myTeamIds = rawTeam.map(x => x.id);
					items = [...this.employees.filter(e =>
						myTeamIds.includes(e.id))];
				}
			}

			let itemIds = items.map(x => x.id);

			// if (this.selectedIds.length > 0) {
			// 	itemIds = [...itemIds.filter(x => !this.selectedIds.includes(x))];
			// }

			if (backImmediately) {
				callback(itemIds);
			}
		},
		getProjectEmployees(callback, projectsToFetch = this.projectIds) {
			if (!projectsToFetch || projectsToFetch.length === 0) {
			callback([]);
			return;
			}
			api.getFullProjectEmployeesByProjectList(
			{ projectsIds: projectsToFetch },
			(projectEmployees) => {
				const valid = projectEmployees
				.filter(x => projectsToFetch.includes(x.projectId) && x.isEnabled)
				.map(x => x.employeeId);
				if (this.filterByProfile) {
				// si aún quisieras aplicar deptos/work, intersecta con this.employees:
				const baseIds = this.employees.map(e=>e.id);
				callback(valid.filter(id => baseIds.includes(id)));
				} else {
				callback(valid);
				}
			},
			(err) => {
				this.$emit("show-alert", { text: err.message, color: "error", timeout: 3000 });
				callback([]);
			}
			);
		},
		getWorkplaceIds() {
			return this.workplaceIds;
		},
		getDepartmentIds() {
			return this.departmentIds;
		},
		getProjectIds() {
			return this.projectIds;
		},
		getLegalEntityIds() {
			return this.legalEntityIds;
		},
		getEmployeeIds() {
			return this.employeeIds;
		},
		getMyTeamIds() {
			if (!gwt.getSessionInformation().myTeam) {
				return [];
			}
			return gwt.getSessionInformation().myTeam.map(x => x.id);
		},
		getWorkplaceIdsAsString() {
			if (this.workplaceIds.length === 0 || this.workplaceIds.length === this.workplacesByProfile.length) {
				return null;
			}

			return this.workplaceIds.toString();
		},
		getDepartmentsAsString() {
			if (this.departmentIds.length === 0 || this.departmentIds.length === this.departmentsByProfile.length) {
				return null;
			}

			return this.departmentIds.toString();
		},
		getLegalEntitiesAsString() {
			if (this.legalEntityIds.length === 0 || this.legalEntityIds.length === this.legalEntities.length) {
				return null;
			}

			return this.legalEntityIds.toString();
		},
		getProjectsAsString() {
			if (this.projectIds.length === 0) {
				return null;
			}

			return this.projectIds.toString();
		},
		getEmployeesAsString() {
			if (this.employeeIds.length === 0) {
				return null;
			}

			return this.employeeIds.toString();
		},
		getMyTeamAsString() {
			if (!gwt.getSessionInformation().myTeam || gwt.getSessionInformation().myTeam.length === 0) {
				return null;
			}

			return gwt.getSessionInformation().myTeam.map(x => x.id).toString();
		},
		onTypeIdChanged(newTypeId) {
			const previousType = this.typeId;
			
			this.typeId = newTypeId;
			this.loadData();
			this.$emit('input', newTypeId);

			if (previousType === 4 && newTypeId !== 4) {
			this.employeeIds = [];
			}

			switch (previousType) {
			case 1:
				this.workplaceIds = [];
				this.departmentIds = [];
				this.legalEntityIds = [];
				break;
			case 2:
				this.projectIds = [];
				break;
			case 3:
				this.employeeIds = [];
				break;
			}

			if (newTypeId === 4) {
				this.myTeam = gwt.getSessionInformation().myTeam;
				if (this.myTeam?.length > 0) {
					const myTeamIds = this.myTeam.map(x => Number(x.id || x.employeeId));
					this.employeeIds = this.isProject 
					? this.employees.filter(x => myTeamIds.includes(x.id) && x.isEnabled).map(x => x.id)
					: myTeamIds.filter(id => this.employees.some(e => e.id === id && e.isEnabled));
				} else {
					this.employeeIds = [];
				}
			}
		}
	},
}
</script>
